// В.2.i: реестр триггеров «в начале своего хода» по cardId.
// Зеркальный каркас к eot-triggers.js.
//
// Семантика «свой ход»: в проекте Ф1 общий для обоих игроков (Ф1→Ф2→Ф3→
// Ф4→Ф5→Ф6 один общий цикл). «Свой» = «для своей стороны». Мы проходим по
// обеим сторонам отдельно — для каждого игрока триггер вызывается один раз
// за раунд по живым юнитам с зарегистрированным cardId.
//
// API:
//   registerOnStartOfTurnTrigger(cardId, fn) — fn(state, card, ownerIdx).
//   runOnStartOfTurnTriggers(state) — проход по обоим игрокам, snapshot
//     поля до прохода (новый юнит за этот же ход не получит триггер
//     повторно).
//
// Молчание блокирует: пропуск, если card.current.silenced или
// card.silenceSources непустой.
//
// Регистрируется через registerOnTurnStartExtraHandler — вызовется в конце
// onTurnStart (после tanaki/strateg/komissar/spawn-passive/per-юнитовых).

import { registerOnTurnStartExtraHandler } from '../deus/hooks.js';

const _sotTriggers = new Map();

export function registerOnStartOfTurnTrigger(cardId, fn) {
  if (typeof cardId !== 'string' || typeof fn !== 'function') return;
  _sotTriggers.set(cardId, fn);
}

// Только для тестов: очистить.
export function _resetOnStartOfTurnTriggersForTests() {
  _sotTriggers.clear();
}

export function runOnStartOfTurnTriggers(state) {
  if (!state?.players) return;
  if (_sotTriggers.size === 0) return;
  for (let idx = 0; idx < 2; idx++) {
    const p = state.players[idx];
    if (!p) continue;
    const snapshot = [];
    for (let line = 0; line < 2; line++) {
      for (let slot = 0; slot < 4; slot++) {
        const u = p.field[line][slot];
        if (u) snapshot.push(u);
      }
    }
    for (const u of snapshot) {
      if (!u.isAlive || !u.isAlive()) continue;
      if (u.current?.silenced) continue;
      if (u.silenceSources && u.silenceSources.size > 0) continue;
      const fn = _sotTriggers.get(u.id);
      if (!fn) continue;
      try {
        fn(state, u, idx);
      } catch (e) {
        console.warn(`[Корпы] start-of-turn-триггер ${u.id} упал:`, e);
      }
    }
  }
}

registerOnTurnStartExtraHandler(runOnStartOfTurnTriggers);
